
import React from 'react';
import { injectIntl } from 'react-intl';
import HelloModal from 'common/components/hello-modal';
import styles from './index.scss';

export class CompleteQualifiedSignature extends React.Component {
  render() {
    const { app } = this.props;

    return (
      <HelloModal
        shouldCloseOnEsc={false}
        isOpen={true}
        onRequestClose={undefined}
        showCloseIcon={false}
        shouldCloseOnOverlayClick={false}
        extraClasses={styles.completeQESModal}
        contentClasses={styles.contentQES}
      >
        <iframe
          src={app.completeQesUrl}
          allow="camera *;microphone *"
          className={styles.iframeContentQES} />
      </HelloModal>
    );
  }
}

export default injectIntl(CompleteQualifiedSignature);
